const topics = [
  { icon: 'ri-movie-2-line', title: '电影大片', desc: '院线热映与经典佳片', color: 'text-primary-400' },
  { icon: 'ri-tv-2-line', title: '热门剧集', desc: '国产剧韩剧美剧全覆盖', color: 'text-accent-400' },
  { icon: 'ri-magic-line', title: '综艺娱乐', desc: '热门综艺实时更新', color: 'text-primary-400' },
  { icon: 'ri-ghost-line', title: '动漫番剧', desc: '日漫国漫精选合集', color: 'text-accent-400' },
  { icon: 'ri-earth-line', title: '纪录片', desc: '自然人文精品纪录', color: 'text-primary-400' },
  { icon: 'ri-smartphone-line', title: '短剧小剧场', desc: '精彩短剧随时随地看', color: 'text-accent-400' },
  { icon: 'ri-moon-line', title: '午夜精选', desc: '深夜专属影视推荐', color: 'text-primary-400' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-500/10 border border-primary-500/20 mb-4">
            <span className="text-xs text-primary-400 whitespace-nowrap">内容导航</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-50 mb-3">影视专题索引</h2>
          <p className="text-sm text-foreground-400 max-w-xl mx-auto">
            按分类快速找到你想看的西瓜视频免费资源和91在线视频内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-4">
          {topics.map((item) => (
            <a
              key={item.title}
              href="#media"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#media')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex flex-col items-center p-5 bg-background-200/60 rounded-xl hover:bg-background-200 transition-colors cursor-pointer"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-full bg-background-300/50 mb-3 group-hover:scale-110 transition-transform`}>
                <i className={`${item.icon} ${item.color} text-xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-200 whitespace-nowrap group-hover:text-primary-400 transition-colors">
                {item.title}
              </span>
              <span className="text-xs text-foreground-500 mt-1 text-center">{item.desc}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}